import React, { useEffect } from "react";

import styles from "./style.module.css";

import Card from "./card";
import { useCookies } from "../../../../hooks/useCookies";
import Loader from "../../../Utility/Loader";
import * as profileAction from "../../../../actions/Profile";

export default function ProfileDetailsPreview({ activeTabs }) {
  const cookies = useCookies();

  const [loading, setLoading] = React.useState(false);
  const [profile, setProfile] = React.useState({});
  const userId = cookies.getCookie("userId");

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await profileAction.fetchDataById(userId);
        if (!response) return;

        if (response) {
          setProfile(response);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [window.location.pathname]);

  return (
    <div className={styles.container}>
      {loading ? (
       <Loader />
      ) : (
        <Card {...profile} show activeTabs={activeTabs} />
      )}
    </div>
  );
}
